import { GetAuthToken } from '../../contexts/AuthContext';
import { trackEvent } from '../../helpers/analytics/trackEvent';
import { ICoupon } from '../../interfaces/stripe';

import { returnJsonOrThrow, get } from './shared';

export const validateCode = async (code: string, getAuthToken: GetAuthToken): Promise<ICoupon> =>
  get(`/premium/coupons/${code}`, getAuthToken)
    .then((response: Response) => {
      void trackEvent({
        name: 'premium_discount_code_validated',
        properties: { valid: response.ok, discount_code: code },
      });
      return response;
    })
    .then(async r => returnJsonOrThrow<ICoupon>(r));
